import { handleGetRequest, handlePostRequest } from "../hooks/api";

export async function createReport(payload) {
  const endpoint = `/report-user/create/`;
  const response = await handlePostRequest(endpoint, payload, undefined);
  if (response?.error) {
    throw new Error(response?.error);
  }
  return response;
}

export async function removeReport(payload) {
  const endpoint = `/report-user/remove/`;
  const response = await handlePostRequest(endpoint, payload, undefined);
  if (response?.error) {
    throw new Error(response?.error);
  }
  return response;
}

export async function listReportedUsers() {
  const endpoint = `/report-user/list/`;
  const response = await handleGetRequest(endpoint, undefined);
  if (response?.error) {
    throw new Error(response?.error);
  }
  return response;
}
